<template>
  <vx-card :class="isActive ? 'active' : 'active'">
    <div class="flex justify-between items-center">
      <div class="flex items-start text-left w-full md:w-11/12">
        <div class="card-image">
          <img
            :src="
              isActive
                ? $options.MY_PATH[currentPath].coloredImageUrl
                : $options.MY_PATH[currentPath].coloredImageUrl
            "
            width="52px"
            height="52px"
          />
        </div>
        <div class="text-left" v-if="currentPath === 'MY_PROFILE'">
          <p class="path-heading mb-2">
            {{ $t(`emotionhack.pathNames.${currentPath}.heading`) }}
          </p>
          <h5 class="mb-2" style="color: #626262">
            {{
              $t(`emotionhack.pathNames.${currentPath}.shortDescription`, {
                orgName: organizationName,
              })
            }}
          </h5>
          <p class="path-long-description">
            {{ $t(`emotionhack.pathNames.${currentPath}.longDescription`) }}
          </p>
        </div>
        <div class="text-left" v-else-if="currentPath !== 'MY_PROFILE'">
          <p class="path-heading mb-2">
            <!--            {{ $t(`emotionhack.pathNames.${currentPath}.shortDescription`,  {-->
            <!--            orgName: organizationName,-->
            <!--          }) }}-->
            <!--          </p>-->
          </p>

          <h5 class="mb-2" style="color: #626262">
            {{ $t(`emotionhack.pathNames.${currentPath}.heading`) }}
          </h5>
          <p class="path-long-description">
            {{ $t(`emotionhack.pathNames.${currentPath}.longDescription`) }}
          </p>
        </div>
      </div>
      <div class="card-action md:w-1/12">
        <img
          v-if="isActive && currentPath === 'MY_PROFILE'"
          src="../../../../../assets/images/pages/emotionhack/accordian.svg"
          width="45px"
          class="cursor-pointer"
          height="auto"
          @click="$emit('rightArrowClicked')"
        />
        <img
          v-else-if="isActive && currentPath !== 'MY_PROFILE'"
          src="../../../../../assets/images/pages/emotionhack/colored-arrow.svg"
          width="45px"
          class="cursor-pointer"
          height="auto"
          @click="$emit('rightArrowClicked')"
        />
        <img
          v-else
          src="../../../../../assets/images/pages/emotionhack/accordian.svg"
          width="45px"
          height="auto"
        />
      </div>
    </div>
  </vx-card>
</template>
<script>
import { MY_PATH } from "@/assets/data/emotionhack";
export default {
  MY_PATH,
  name: "MyPathCard",
  props: {
    currentPath: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
  },
  created() {
    let url = this.$route.path.split("/");
    this.organizationName = url[1];
  },
};
</script>
<style scoped>
p {
  line-height: unset;
  font-size: unset;
}
h5 {
  font-weight: bold;
}
.inactive div.card-image {
  background-color: #ffffff !important;
}
.active div.card-image {
  background-color: #ffffff;
}

.card-image {
  margin-right: 1.25rem;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.s-head {
  margin-bottom: 0.2rem;
}

.active p.path-heading {
  color: #f29300;
}

.active h5 {
  color: #231d4f;
}
.active p.path-long-description {
  color: #848199;
}
.inactive h5,
.inactive p {
  color: #ccc !important;
}
.vx-card.inactive {
  border: 1px solid #eaf1fb;
}

@media screen and (max-width: 500px) {
 .vx-card >>> .vx-card__body{
    padding: 0.25rem !important;
  }
  .card-image{
    padding: 0.2rem;
     margin-right: 0.3rem;
  }
}
</style>
